import { Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";

const PageTitle = ({ parts }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.75,
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: 0,
          top: 6,
          height: "50%",
          width: 4,
          borderRadius: 2,
          background: `linear-gradient(180deg, ${theme.palette.primary.main}, ${theme.palette.primary.main})`,
        }}
      />

      <Typography
        sx={{
          ml: 1.5,
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: "0.04em",
          textTransform: "uppercase",
          color: theme.palette.text.secondary,
        }}
      >
        {parts?.slice(0, -1).join(" · ") || "Overview"}
      </Typography>

      <Typography
        sx={{
          ml: 1.5,
          pb: 2,
          fontWeight: 650,
          letterSpacing: "-0.03em",
          fontSize: { xs: 22, sm: 28 },
          lineHeight: 1.05,
          background: `linear-gradient(90deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.main} 100%)`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {parts && parts[parts.length - 1]}
      </Typography>
    </Box>
  );
};

export default PageTitle;
